import { render } from "./ImportProtocol.vue?vue&type=template&id=3300ea3e&scoped=true"
import script from "./ImportProtocol.js?vue&type=script&lang=js"
export * from "./ImportProtocol.js?vue&type=script&lang=js"

import "./ImportProtocol.vue?vue&type=style&index=0&id=3300ea3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3300ea3e"]])

export default __exports__